import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from '../../../utils'

/**
 * Dedicated CONTRACTOR (hauler-manager) workspace route group (SPEC §4 W4,
 * decisions D11/D8). Every screen here is hauler-scoped by the backend, so the
 * contractor only ever sees their own data. Office-only concepts are absent by
 * construction — these routes are gated hauler-only (see route-config).
 */
// Page titles are role-neutral nouns, never "My …" (PRO-36): several people
// at a hauler (route planner, contractor manager, …) share these screens, so
// "my" misleads. Everything here is already hauler-scoped by the backend.
export const createContractorRouteMap = (prefix: string) => ({
  home: pathJoin(prefix)('home').chainWithTitle({
    title: <T _str="Overview" />,
    breadCrumbTitle: <T _str="Overview" />,
  }),
  company: pathJoin(prefix)('company').chainWithTitle({
    title: <T _str="Company & fleet" />,
    breadCrumbTitle: <T _str="Company & fleet" />,
  }),
  // Contractor self-service user management (PRO-30, 3.5.55): the manager
  // runs their own crew — roster, invite, edit, deactivate — without a
  // single office action. Invite/edit are full pages, not modals.
  users: pathJoin(prefix)('users').chainMapAuto(
    (prefix2) => ({
      invite: pathJoin(prefix2)('invite').chainWithTitle({
        title: <T _str="Invite user" />,
        breadCrumbTitle: <T _str="Invite user" />,
      }),
      ':id': (id = ':id') =>
        pathJoin(prefix2)(id).chainMapAuto(
          (prefix3) => ({
            edit: pathJoin(prefix3)('edit').chainWithTitle({
              title: <T _str="Edit user" />,
              breadCrumbTitle: <T _str="Edit user" />,
            }),
          }),
          {
            title: <T _str="User" />,
            breadCrumbTitle: <T _str="User" />,
          }
        ),
    }),
    {
      title: <T _str="Users" />,
      breadCrumbTitle: <T _str="Users" />,
    }
  ),
  proposals: pathJoin(prefix)('proposals').chainWithTitle({
    title: <T _str="Proposals" />,
    breadCrumbTitle: <T _str="Proposals" />,
  }),
  prices: pathJoin(prefix)('prices').chainWithTitle({
    title: <T _str="Prices" />,
    breadCrumbTitle: <T _str="Prices" />,
  }),
  settlement: pathJoin(prefix)('settlement').chainWithTitle({
    title: <T _str="Settlement" />,
    breadCrumbTitle: <T _str="Settlement" />,
  }),
  'settlement-report': pathJoin(prefix)('settlement-report').chainWithTitle({
    title: <T _str="Settlement report" />,
    breadCrumbTitle: <T _str="Settlement report" />,
  }),
  performance: pathJoin(prefix)('performance').chainWithTitle({
    title: <T _str="Performance" />,
    breadCrumbTitle: <T _str="Performance" />,
  }),
  feedback: pathJoin(prefix)('feedback').chainWithTitle({
    title: <T _str="Feedback" />,
    breadCrumbTitle: <T _str="Feedback" />,
  }),
  // Task 06 (REQ 3.5.58, PRODUCT-83 M6): read-only holiday-impact twin —
  // operational, not commercial, so it sits beside Performance/Feedback
  // (no RequireContractorManager gate).
  'holiday-impact': pathJoin(prefix)('holiday-impact').chainWithTitle({
    title: <T _str="Holiday impact" />,
    breadCrumbTitle: <T _str="Holiday impact" />,
  }),
})
